import React, {Component} from "react"

import ChromeIcon from "../assets/icons/chrome.png"

const wrapperStyle = {
    position: "absolute",

    left: 0,
    right: 0,

    color: 'white',
    fontFamily: "Sans-Serif",
    fontWeight: '100',

    width: '100%',
    height: '100%',

    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center',
    flexWrap: 'wrap',

    backgroundColor: 'rgba(66,66,66, 0.9)',
}

const inputStyle = {
    fontSize: "24pt",

    width: "100%",
}

const closeStyle = {
    border: 0,
    backgroundColor: "grey",

    color: "white",

    fontSize: "14pt",

    padding: 10,
    width: 40,
    height: 40,

    borderRadius: 20,

}

const selectHeading = {
    textAlign: "center",

}

const selectList = {
    listStyle: "none",
    paddingLeft: 0,

}

const selectItem = {
    paddingBottom: '0.4em',
    paddingTop: '0.4em',
    borderBottom: "1px solid white",

    // 'margin-right': "1em",
}

const selectButton = {
    outline: "none",
    background: "none",

    fontSize: "14pt",
    color: "white",

    border: "none",

    cursor: "pointer",
}

const selectActiveButton = {
    ...selectButton,

    color: "#BDBDBD",
}

const editButton = {
    outline: "none",
    backgroundColor: "#424242",

    borderRadius: 5,

    color: "white",

    border: "none",
    cursor: "pointer",
}

const deleteButtonHidden = {
    outline: "none",
    backgroundColor: "#424242",

    borderRadius: 5,

    color: "white",

    border: "none",
    cursor: "pointer",

    display: "none",

}

const addButton = {
    ...editButton,

    lineHeight: 3,
    width: 40,

    // 'padding-bottom': 20,
}


class ListItemHUD extends Component {
    constructor(props) {
        super(props)

        this.state = {
            editing: false,
            name: this.props.space.name,
            spaces: this.props.spaces,
        }
    }

    toggleEdit() {
        const newEdit = !this.state.editing
        this.setState({
            editing: newEdit,
        })
    }

    // updateName(e) {
    //     this.setState({
    //         name: e.target.value
    //     })
    // }
    componentWillReceiveProps(newProps){
      this.state.spaces = newProps.spaces
    }


    render() {
        return (
            <div>
                {(!this.state.editing) ?
                    (<button style={(this.props.highligth) ? selectActiveButton : selectButton } onClick={this.props.action}>{this.props.space.name}</button>) :

                    (<input value={this.props.space.name} onChange={(e) => this.props.nameUpdate(e.target.value)} />)
                }

                <button style={editButton} onClick={() => this.toggleEdit()}>{ (!this.state.editing) ? "edit" : "save"}</button>

                {(this.state.spaces.length > 1) ?
                    (<button style={editButton} onClick={() => this.props.deleteSpace()}>delete</button>):

                    (null)
                }

            </div>
        )
    }
}

class HUD extends Component {

    constructor(props) {
        super(props)

        this.state = {
            copied: false,
        }

        // document.addEventListener("keypress", this.releaseWindow.bind(this))
    }

    releaseWindow() {
        // console.log("key Press")
        // this.props.disableHUD()
    }

    handleFocus(e) {
        e.target.select()
        const sucs = document.execCommand("copy")

        console.log(this.setState({
            copied: sucs,
        }))
    }

    linkShare() {
        return (
            <div>
                <div>
                    <button style={closeStyle} onClick={() => this.props.disableHUD()}>X</button>
                </div>
                <h1>Your Space Is Now Shared. { (this.state.copied) ? "Copied URL" : ""  }</h1>
                <input ref={ (i) => {this.inputF = i} } type="text" style={inputStyle} value={this.props.hud.link} onFocus={this.handleFocus.bind(this)} />
            </div>
        );
    }

    speechError() {
        return (
            <div>
                <img width={100} src={ChromeIcon} />
                <h2>Due To Technical Limitation Our Demo Only Works On Latest Version Of Google Chrome :(</h2>
            </div>
        );
    }

    selectScene() {
        console.log("Selecting Scene")
    }


    spaceSelection() {
        return (
            <div>

                <div>
                    <button style={closeStyle} onClick={() => this.props.disableHUD()}>X</button>
                </div>

                <h1 style={selectHeading}><span>Select Space</span> <button style={addButton} onClick={() => this.props.addSpace("New Space")}>+</button></h1>

                <ul style={selectList}>
                    {this.props.spaces.map( (space, index) => {
                        return (
                            <li style={selectItem} key={index}>
                                <ListItemHUD
                                    idx={index}
                                    space={space}
                                    spaces={this.props.spaces}
                                    highligth={(index === this.props.curSpace) ? true : false}
                                    nameUpdate={(n) => this.props.updateSpaceName(n, index) }
                                    deleteSpace={() => this.props.deleteSpace(index)}
                                    action={() => this.props.switchSpace(index)}

                                />
                            </li>
                        )
                    })
                  }
                </ul>
            </div>
        )

    }

    loading() {
        return (
            <div>
                <h1>Generating Link</h1>
            </div>
        )
    }

    switchRenderer() {
        switch (this.props.hud.state) {
            case "SPEECH_ERROR":
                return this.speechError()

            case "LINK_SHARE":
                return this.linkShare()

            case "SPACE_SWITCH":
                return this.spaceSelection()

            case "CREATING_LINK":
                return this.loading()
        }

    }

    componentDidUpdate() {
        if (this.props.hud.state !== "LINK_SHARE") return

        // this.inputF.focus()

        // this.inputF.select()
        // const sucs = document.execCommand("copy")
        // console.log(sucs)
    }

    render() {

        return (
            <div style={{
                ...wrapperStyle,
                display: (this.props.hud.visible) ? "flex" : "none",
            }}
            >
                {/* {(this.props.hud.speechError) ? this.speechError() : this.linkShare()} */}

                { this.switchRenderer() }
            </div>
        );
    }
}

export default HUD;



// WEBPACK FOOTER //
// ./src/components/hud.js